export default __webpack_public_path__ + "static/media/Status-Aesthetic-Clinic.56c90e3f.png";